import { FormGroup, AbstractControl } from '@angular/forms';
import * as moment from 'moment';

export class UtilHelper {

  public static readonly MsgGenericas = {
    senha_minlength: 'Senha inválida. A senha deve possuir no mínimo 6 caracteres.',
    senha_maxlength: 'A senha deve possuir no máximo 15 caracteres.',
    senha_naoConfirmada: 'Senhas Incorretas! A senha e a confirmação de senha devem ser iguais.',
    email_pattern: 'E-mail inválido. Informe um E-mail válido.',
    email_NaoConfirmado: 'E-mail e confirmação estão diferentes. Verifique.'
  };

    public static lpad(valor: string, tamanho: number): string {
        const qtdCaracteres = valor.length;
        const qtdCaracterAdicionar = tamanho - qtdCaracteres;
        const valorFormat = '0'.repeat(qtdCaracterAdicionar) + valor;

        return valorFormat;
    }

    public static ParseDateFormat(valorData: Date, formatIn: string, formatOut: string): Date {
         return moment(moment(valorData, formatIn).format(formatOut)).toDate();
    }

    public static ParseStringToDate(valorData: string, formatIn: string, formatOut: string): Date {
        return moment(moment(valorData, formatIn).format(formatOut)).toDate();
    }

    public static IsDate(valorData: string, formatIn: string): boolean {
        return moment(valorData, formatIn).isValid();
    }

    public static ParseDateToString(valorData: Date, formatIn: string, formatOut: string): string {
        return moment(valorData, formatIn).format(formatOut);
    }

    public static onValueChanged(data: any, formErrors: any, validationMessages: any, form: FormGroup): void {
        for (const campo in formErrors) {
            const control = form.get(campo);
            formErrors[campo] = [];
            if (this.validarControl(control)) {
                const messages = validationMessages[campo];
                for (const key in control.errors) {
                    if (messages[key]) {
                        formErrors[campo] = [];
                        formErrors[campo].push(messages[key]);
                    }
                }
            }
        }
    }

    public static objectWithoutProperties(modelObject: any, valueObject: any, keys: Array < any > ): any {
        const target: any = {};

        for (const i in valueObject) {
            if (keys.indexOf(i) < 0 && Object.prototype.hasOwnProperty.call(valueObject, i)) {
                target[i] = valueObject[i];
            }
        }
        return Object.assign(modelObject, target);
    }

    public static validarControl(_control: AbstractControl): boolean {
      return _control && _control.dirty && !_control.valid;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/util-helper.ts